export const getParcels = state => state.returns.parcels;
export const getAccount = state => state.returns.account;
export const getFindbyCode = state => state.returns.findByCode;
export const getFindbyTotal = state => state.returns.findByTotal;
